import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    border-bottom: 1px solid #D6D6D6;
    margin-top: 16px;
    box-sizing: border-box;
    padding: 20px;

    ::-webkit-scrollbar {
        width: 8px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #949494;
        border-radius: 4px;
    }

    .rti--container {
        width: 100%;

    }

    .rti--tag {
        padding: 5px;
        background-color: #FFF;

        span {
            font-size: 10px;
        }
    }

    input, select {
        width: 100%;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #F3F3F3;
        border-radius: 5px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 10px;
        outline: none;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #4D4D4D;
    }

    textarea {
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        border: 1px solid #F3F3F3;
        border-radius: 5px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 10px;
        outline: none;
        resize: none;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #4D4D4D;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    >button {
        margin-left: 10px;
    }
`;

export const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    background: ${props => props.background ? props.background : 'transparent'};
    border: ${props => props.border ? props.border : 'none'};
    color: ${props => props.color ? props.color : ''};
    border-radius: 5px;
    cursor: pointer;
`;

export const AlertContainer = styled.div`
    display: flex;
    width: 250px;
    height: 200px;
    position: absolute;
    flex-direction: column;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    border-radius: 5px;
    justify-content: center !important;
    align-items: center !important;
    z-index: 10;

    background: ${props => props.theme.asideColor};

    h1 {
        text-align: center; 
        font-size: 22px;
        color: ${props => props.theme.secondaryColor};
    }

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

`